(function() {
    function throttle(func, timeFrame) {
        var lastTime = 0;
        return function (...args) {
            var now = new Date();
            if (now - lastTime >= timeFrame) {
                func(...args);
                lastTime = now;
            }
        };
    }

    function CSSPolyfillAspectRatioUpdate() {
        /*
         * Ce polyfill est un polyfill simplifié adapté à l'usage qui est fait de la propriété aspect-ratio dans ce projet.
         * Utilisé dans : Page d'accueil, carte "Entête vidéo" et carte "Focus".
         */
        const aspectRatioRegex = /\s*([0-9.]+)\s*\/\s*([0-9.]+)\s*/;
        const elements = Array.from(document.querySelectorAll('.js-use-aspect-ratio-polyfill'));
        for (const element of elements) {
            const computedStyles = getComputedStyle(element);
            const aspectRatio = computedStyles.getPropertyValue('--css-polyfill-aspect-ratio');
            const parsedAspectRatio = aspectRatioRegex.exec(aspectRatio);
            if (parsedAspectRatio) {
                const widthValue = parseFloat(computedStyles.width);
                const heightValue = parseFloat(computedStyles.height);
                const [ , x, y, ] = parsedAspectRatio;
                const parsedX = parseFloat(x);
                const parsedY = parseFloat(y);
                if (widthValue) {
                    const computedHeight = widthValue / (parsedX / parsedY);
                    element.style.height = computedHeight + 'px';
                } else if (element.style.height) {
                    const computedWidth = heightValue * (parsedX / parsedY);
                    element.style.width = computedWidth + 'px';
                }
            }
        }
    }

    if (!(CSS.supports('aspect-ratio', '1/1'))) {
        window.addEventListener('load', CSSPolyfillAspectRatioUpdate);
        window.addEventListener('resize', throttle(CSSPolyfillAspectRatioUpdate, 20));
    }

    window.addEventListener('load', function() {
        const pageAccueil = document.querySelector('.ficheaccueil.layout--nantesuniv');
        if (!pageAccueil) return;

        const enteteVideoCards = pageAccueil.querySelectorAll('.entete-video-card');
        for (let card of enteteVideoCards) {
            const video = card.querySelector('.entete-video-card__video');
            const controle = card.querySelector('.entete-video-card__controle');
            if (video) {
                if (!(video.loop)) {
                    video.addEventListener('ended', () => {
                        animate((value) => {
                            video.style.opacity = value / 100.0;
                            if (controle) {
                                controle.style.opacity = value / 100.0;
                            }
                            if (value <= 0) {
                                video.parentNode.removeChild(video);
                                controle.parentNode.removeChild(controle);
                            }
                        }, 100, 0, 500);
                    })
                }
                if (controle) {
                    controle.addEventListener('click', () => {
                        if (video.paused) {
                            controle.classList.remove('entete-video-card__controle--paused');
                            controle.classList.add('entete-video-card__controle--playing');
                            video.play();
                        } else {
                            controle.classList.remove('entete-video-card__controle--playing');
                            controle.classList.add('entete-video-card__controle--paused');
                            video.pause();
                        }
                    });
                }
            }
            const scroll = card.querySelector('.entete-video-card__scroll');
            scroll.addEventListener('click', () => {
                animate((value) => {
                    window.scrollTo(0, value);
                }, window.scrollY, card.getBoundingClientRect().bottom, 500);
            });
        }
    });
})();